import { render, staticRenderFns } from "./headerTpl.vue?vue&type=template&id=90f28c14&scoped=true&"
import script from "./headerTpl.vue?vue&type=script&lang=js&"
export * from "./headerTpl.vue?vue&type=script&lang=js&"
import style0 from "./headerTpl.vue?vue&type=style&index=0&id=90f28c14&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f28c14",
  null
  
)

export default component.exports